"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var SmsFailedOutlined_1 = __importDefault(require("../Icon/icons/SmsFailedOutlined"));
var DoneOutlined_1 = __importDefault(require("../Icon/icons/DoneOutlined"));
var ErrorOutline_1 = __importDefault(require("../Icon/icons/ErrorOutline"));
var InfoOutlined_1 = __importDefault(require("../Icon/icons/InfoOutlined"));
var defaultIcons = {
    alert: React.createElement(ErrorOutline_1.default, null),
    com: React.createElement(SmsFailedOutlined_1.default, null),
    positive: React.createElement(DoneOutlined_1.default, null),
};
var renderIcon = function (icon, theme) {
    if (icon) {
        return React.createElement("span", { className: "t2-icon" }, icon);
    }
    else if (theme) {
        return React.createElement("span", { className: "t2-icon" }, defaultIcons[theme]);
    }
    return (React.createElement("span", { className: "t2-icon" },
        React.createElement(InfoOutlined_1.default, null)));
};
var InfoMessage = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), children = _a.children, className = _a.className, ghost = _a.ghost, icon = _a.icon, theme = _a.theme, rest = __rest(_a, ["children", "className", "ghost", "icon", "theme"]);
    var classes = (0, classnames_1.default)('t2-msg', {
        't2-ghost': ghost,
        't2-alert': theme === 'alert',
        't2-com': theme === 'com',
        't2-positive': theme === 'positive',
    }, className);
    return (React.createElement("div", __assign({ className: classes }, rest),
        renderIcon(icon, theme),
        children));
};
exports.default = InfoMessage;
